import { getTimeDifference } from 'util/dateTime';

import { Shift } from './types';

export const shiftSortCompare = (a: Shift, b: Shift) => {
  const t1 = a.startAt;
  const t2 = b.startAt;

  if (t1 !== t2) {
    return new Date(t1) < new Date(t2) ? -1 : 1;
  }

  const td1 = getTimeDifference(a.startAt, a.endAt);
  const td2 = getTimeDifference(b.startAt, b.endAt);

  if (t1 === t2 && td1 !== td2) {
    return td1 > td2 ? -1 : 1;
  }

  if (a.isOpen !== b.isOpen) {
    if (a.isOpen) {
      return -1;
    } else if (b.isOpen) {
      return 1;
    }
  }

  if (a.roleName !== b.roleName) {
    if (!a.roleName) {
      return -1;
    } else if (!b.roleName) {
      return 1;
    }
    return a.roleName.localeCompare(b.roleName);
  }

  return parseInt(a.id as string, 10) < parseInt(b.id as string, 10) ? -1 : 1;
};
